module.exports = __webpack_public_path__ + "static/media/download-icon.97ce2c60.svg";